<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <router-link class="el-button el-button--success el-button--cons" :to="$location.notice_edit({},false)">
      <icon name="plus"></icon>
      创建新通知
    </router-link>
    <div class="clearfix m-t-20">
      <el-tabs v-model="tab_active_name" @tab-click="updateList" class="pull-left">
        <el-tab-pane :label="'全部（' + list[2].length + '）'" name="all"></el-tab-pane>
        <el-tab-pane :label="'已发布（' + list[1].length + '）'" name="published"></el-tab-pane>
        <el-tab-pane :label="'未发布（' + list[0].length + '）'" name="unpublished"></el-tab-pane>
      </el-tabs>
      <el-input placeholder="搜索通知" class="pull-right max-width-200 w-a"
                suffix-icon="el-icon-search" v-model="search"></el-input>
    </div>
    <el-table :data="page" border>
      <template slot="empty">
        <div v-if="ready">
          <div v-if="!list.length">暂无数据</div>
          <div v-else-if="!filtered.length">无匹配结果</div>
        </div>
      </template>
      <el-table-column v-for="item in form" :label="item.name" :prop="item.prop" sortable :key="item.prop">
        <template slot-scope="scope">
          <span v-if="item.prop === 'status'"
                :class="'status'+scope.row[item.prop]">{{status[scope.row[item.prop]]}}</span>
          <span v-else v-html="$highlight(scope.row[item.prop], scope.row.$$pinyin[item.prop])"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <router-link
            :to="scope.row.status === '1' ? $location.notice_detail({notice_uid:scope.row.uid}) : $location.notice_edit({notice_uid:scope.row.uid},false)"
            class="el-button el-button--primary el-button--mini">查看
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="group_list.length>pageInfo.page" :total="group_list.length"
                   :page-size="pageInfo.page" :current-page.sync="pageInfo.current"
                   class="text-center m-t-10" layout="prev, pager, next"></el-pagination>
  </div>
</template>

<script>
import * as Notice from 'api/notice'
import page from 'utils/page'

import groupBy from 'lodash/groupBy'

export default {
  data () {
    return {
      tab_active_name: 'all',
      ready: false,
      list: null,
      group_list: null,
      form: null,
      status: null,
      pageInfo: {page: 5, current: 1},
      search: '',
      searchFields: ['title', 'department', 'admin', 'pubdate', 'receiver'],
    }
  },
  computed: {
    filtered () {
      return this.$search(this.group_list, this.search, this.searchFields)
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [list, status, form_brief] = await Promise.all([Notice.list(), Notice.status(), Notice.form_brief()])
        this.list = [groupBy(list, 'status')['0'], groupBy(list, 'status')['1'], list]
        this.group_list = list
        this.form = form_brief
        this.status = status
        this.ready = true
      })
    },
    updateList () {
      this.pageInfo.current = 1
      switch (this.tab_active_name) {
        case 'all':
          this.group_list = this.list[2]
          break
        case 'published':
          this.group_list = this.list[1]
          break
        case 'unpublished':
          this.group_list = this.list[0]
          break
      }
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
.status0 {
  color: red;
  font-weight: bold;
}

.status1 {
  color: deepskyblue;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeList.vue